import {Component} from 'react'
import {Redirect} from 'react-router-dom'

import Cookies from 'js-cookie'

import './index.css'

class LoginForm extends Component {
  state = {username: '', password: '', showError: false, errorMessage: ''}

  onChangeUsername = event => {
    this.setState({username: event.target.value})
  }

  onChangePassword = event => {
    this.setState({password: event.target.value})
  }

  onLoginSuccess = jwtToken => {
    const {history} = this.props

    Cookies.set('jwt_token', jwtToken, {
      expires: 30,
    })

    history.replace('/')
    
  }

  onLoginFailure = errorMessage => {
    this.setState({showError: true, errorMessage})
  }

  onLogin = async event => {
    event.preventDefault()
    const {username, password} = this.state

    const apiUrl = 'https://interview-platform-backend-gnqj.onrender.com/login'
    const userDetails = {username, password}
    const option = {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(userDetails),
}

    const response = await fetch(apiUrl, option)
    const data = await response.json()
    console.log(data)

    if (response.ok === true) {
      this.onLoginSuccess(data.token)
    } else {
      this.onLoginFailure(data.error_msg)
    }
  }

  render() {
    const {errorMessage, showError} = this.state

    const jwtToken = Cookies.get('jwt_token')

    if (jwtToken !== undefined) {
      return <Redirect to="/" />
    }

    return (
      <div className="bg-container">
        <div className='platform-info'>
          <h1>Prepare Smarter. Interview Better</h1>
          <p>Practice real interview questions and build confidence with timed mock interviews.</p>
          <p>
            🎯 Curated interview questions<br/>

            ⏱️ Timed mock interview mode<br/>

            ⭐ Bookmark important questions<br/>

            📊 Daily Challenges<br/>
          </p>
          <h2>Practice • Improve • Get Hired</h2>
        </div>
        <div className='form-main-container'>
          <form className="form-container" onSubmit={this.onLogin}>
          <div className="input-container">
            <div className="input-item">
              <label htmlFor="username">USERNAME</label>
              <input
                placeholder="Username"
                id="username"
                type="text"
                onChange={this.onChangeUsername}
              />
            </div>
            <div className="input-item">
              <label htmlFor="password">PASSWORD</label>
              <input
                placeholder="Password"
                id="password"
                type="password"
                onChange={this.onChangePassword}
              />
            </div>
          </div>
          <button type="submit" className="login-button">
            Login
          </button>
          {showError && <p className="error-message">{`*${errorMessage}`}</p>}
          <a className="register-link" href="/register">Register</a>
        </form>
        </div>
      </div>
    )
  }
}

export default LoginForm